"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _word = _interopRequireDefault(require("./word"));
var _concept_basic = _interopRequireDefault(require("./concept_basic"));
var _source = _interopRequireDefault(require("./source"));
var _word_association_state = _interopRequireDefault(require("./word_association_state"));
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordAssociation = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept_basic["default"]))), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_source["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function WordAssociation(obj) {
    var _this;
    _classCallCheck(this, WordAssociation);
    _this = _callSuper(this, WordAssociation, [obj]);
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "position", _descriptor2, _this);
    _initializerDefineProperty(_this, "punctuation", _descriptor3, _this);
    _initializerDefineProperty(_this, "precedingPunctuation", _descriptor4, _this);
    _initializerDefineProperty(_this, "firstInSentence", _descriptor5, _this);
    _initializerDefineProperty(_this, "sourceId", _descriptor6, _this);
    _initializerDefineProperty(_this, "selected", _descriptor7, _this);
    _initializerDefineProperty(_this, "blankSource", _descriptor8, _this);
    _initializerDefineProperty(_this, "targetTextFromWordAssociation", _descriptor9, _this);
    _initializerDefineProperty(_this, "alternateText", _descriptor10, _this);
    _initializerDefineProperty(_this, "caseTrainerEligible", _descriptor11, _this);
    _initializerDefineProperty(_this, "word", _descriptor12, _this);
    _initializerDefineProperty(_this, "smartyWord", _descriptor13, _this);
    _initializerDefineProperty(_this, "concepts", _descriptor14, _this);
    _initializerDefineProperty(_this, "source", _descriptor15, _this);
    _this.state = new _word_association_state["default"](_this);
    return _this;
  }
  _inherits(WordAssociation, _RootModel);
  return _createClass(WordAssociation, [{
    key: "conceptIds",
    get: function get() {
      return this.concepts.map(function (item) {
        return item.id;
      });
    }
  }, {
    key: "infinitiveConcept",
    get: function get() {
      return this.concepts.find(function (item) {
        return item.showAsInfinitive;
      });
    }
  }, {
    key: "displayConcepts",
    get: function get() {
      var allConcepts;
      if (this.concepts) {
        var waConcepts = this.concepts.filter(function (item) {
          return item.showAsConcept;
        });
        if (this.word.concepts) {
          allConcepts = waConcepts.concat(this.word.concepts.filter(function (item) {
            return item.showAsConcept;
          }));
        } else {
          allConcepts = waConcepts;
        }
        return (0, _lodash.orderBy)(allConcepts, ['vocab'], ['asc']);
      }
      return null;
    }
  }, {
    key: "vocabConcepts",
    get: function get() {
      return this.displayConcepts.filter(function (item) {
        return item.vocab;
      });
    }
  }, {
    key: "nonvocabConcepts",
    get: function get() {
      return this.displayConcepts.filter(function (item) {
        return !item.vocab;
      });
    }
  }, {
    key: "targetText",
    get: function get() {
      if (this.targetTextFromWordAssociation) {
        if ((0, _utils.isPresent)(this.word) && this.word.isNumber && !this.word.isDate && !isNaN(Number(this.targetTextFromWordAssociation))) {
          return Number(this.targetTextFromWordAssociation).toLocaleString(this.word.languageId);
        }
        return this.targetTextFromWordAssociation;
      }
      return (0, _utils.isPresent)(this.word) ? this.word.formattedTargetText : null;
    }
  }, {
    key: "hasSource",
    get: function get() {
      return (0, _utils.isPresent)(this.source) && !this.blankSource && (0, _utils.isPresent)(this.source.text);
    }
  }, {
    key: "sourceText",
    get: function get() {
      return this.hasSource ? this.source.formattedText : null;
    }
  }, {
    key: "sourceTextForUser",
    value: function sourceTextForUser(user) {
      return user !== null && user !== void 0 && user.useBritishEnglish && this.source && this.source.ukSpelling ? this.source.ukSpelling : this.sourceText;
    }
  }, {
    key: "adjustedTargetText",
    get: function get() {
      // logic handles case like normalized text is "wG" and should be "WG"
      if ((0, _utils.isBlank)(this.targetText)) {
        return '';
      }
      return this.firstInSentence ? "".concat((0, _lodash.capitalize)(this.targetText[0])).concat(this.targetText.substr(1, this.targetText.length)) : this.targetText;
    }
  }, {
    key: "adjustedTargetTextForExercise",
    value: function adjustedTargetTextForExercise(exercise) {
      if ((0, _utils.isBlank)(this.targetText)) {
        return '';
      }
      if ((0, _utils.isBlank)(exercise) || exercise.capitalizeEntries) {
        return this.adjustedTargetText;
      }
      return this.targetText;
    }
  }, {
    key: "wordCaseConcept",
    get: function get() {
      var _this$word;
      return (_this$word = this.word) === null || _this$word === void 0 || (_this$word = _this$word.concepts) === null || _this$word === void 0 ? void 0 : _this$word.find(function (concept) {
        return concept.grammarCase;
      });
    }
  }, {
    key: "setSelected",
    value: function setSelected(selected) {
      this.selected = selected;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "punctuation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "precedingPunctuation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "firstInSentence", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sourceId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selected", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "blankSource", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "targetTextFromWordAssociation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "alternateText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "caseTrainerEligible", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "smartyWord", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "concepts", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "source", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "conceptIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conceptIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "infinitiveConcept", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "infinitiveConcept"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayConcepts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayConcepts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabConcepts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabConcepts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nonvocabConcepts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nonvocabConcepts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sourceText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adjustedTargetText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adjustedTargetText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adjustedTargetTextForExercise", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "adjustedTargetTextForExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordCaseConcept", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordCaseConcept"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelected", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelected"), _class.prototype), _class);
var _default = exports["default"] = WordAssociation;